/* okec-price-sync.js  v1 (2026-08-26)
 * 特集LP（okec型HTML）の商品カード内の価格を、Shopifyの現在価格に自動で合わせる。
 * 仕組み: .okec-product 内のリンクから商品handleを取り、/products/(handle).js（認証不要の公開API）
 *         から price_min を取得して li.is-price を書き換える。
 * 前提: 通貨はJPY（.jsの価格は100倍で返るので /100 する）。失敗時は何もしない（元の価格が残る）。
 * 注意: .js の available は当店では全商品falseで返るため在庫判定には使わない（価格のみ扱う）。
 */
(function () {
  if (window.__okecPriceSync) return;
  window.__okecPriceSync = true;

  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }

  function run() {
    var cards = document.querySelectorAll('.okec-product');
    if (!cards.length) return;

    var byHandle = {};
    Array.prototype.forEach.call(cards, function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var priceEl = card.querySelector('.is-price');
      if (!a || !priceEl) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]);
      (byHandle[handle] = byHandle[handle] || []).push({ card: card, priceEl: priceEl });
    });

    var handles = Object.keys(byHandle);
    var checked = 0, changed = 0, failed = 0;
    function report() {
      if (checked + failed !== handles.length) return;
      if (window.console) console.log('okec-price-sync: ' + handles.length + '商品を確認 / ' + changed + '件を最新価格に更新 / ' + failed + '件取得失敗');
    }
    handles.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || typeof p.price_min !== 'number') { failed++; report(); return; }
          var min = p.price_min / 100;   // JPY: 67000 → 670
          var max = (typeof p.price_max === 'number' ? p.price_max : p.price_min) / 100;
          var text = yen(min) + '（税込）' + ((max - min) !== 0 ? '〜' : '');
          byHandle[handle].forEach(function (t) {
            if (t.priceEl.textContent.trim() !== text) {
              t.priceEl.textContent = text;
              t.priceEl.setAttribute('data-okec-synced', 'updated');
              changed++;
            } else {
              t.priceEl.setAttribute('data-okec-synced', 'ok');
            }
          });
          checked++; report();
        })
        .catch(function () { failed++; report(); /* 失敗時は元の価格のまま */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
